}
<template>
  <div class="tc-15-table-fixed-body" style="overflow:hidden;">
    <table class="tc-15-table-box tc-15-table-rowhover">
      <colgroup>
        <col>
        <col style="width: 100px;">
        <col style="width: 100px;">
      </colgroup>
      <tbody>
        <tr class="tc-master-row checked" @click="selectedSession = credential">
          <td>
            <label class="form-ctrl-label text-overflow" :title="credential.AccessPath || $t('core.root')">
              <input type="radio" class="tc-15-radio mr-8" v-model="selectedSession" :value="credential">
              {{credential.AccessPath || $t('core.root')}}
            </label>
          </td>
          <td>
            <div class="text-overflow">{{regionMap[credential.Region] || credential.Region}}</div>
          </td>
          <td>
            <div>
              <qc-bubble trigger="hover" type="dark" v-if="credential.AccessPath">
                <div class="cos-icon--16 use" @click="onUse(credential)"></div>
                <template slot="popup">{{$t('core.use')}}</template>
              </qc-bubble>
              <qc-bubble trigger="hover" type="dark" v-if="credential.AccessPath">
                <div class="cos-icon--16 rename ml-10" @click="onEdit(credential)"></div>
                <template slot="popup">{{$t('core.edit')}}</template>
              </qc-bubble>
              <!-- Placeholder -->
              <div class="cos-icon--16" v-else></div>
              <qc-bubble trigger="hover" type="dark" v-if="credential.AccessPath">
                <div class="cos-icon--16 cancel ml-10" @click="onDelete(credential)"></div>
                <template slot="popup">{{$t('core.delete')}}</template>
              </qc-bubble>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from 'lodash';
import { getInnerProps } from '@/scripts/tools/utils';

export default {
  model: {
    prop: 'session',
    event: 'update:session',
  },
  props: {
    regionMap: Object,
    content: Object,
    session: Object,
  },
  computed: {
    selectedSession: getInnerProps('session'),
    credential() {
      const cred = _.cloneDeep(this.content);
      delete cred.Contents;
      delete cred.edit;
      delete cred.simpleSecretId;
      return cred;
    },
  },
  methods: {
    onEdit(item) {
      this.$emit('edit', item);
    },
    onDelete(item) {
      this.$emit('delete', item);
    },
    onUse(item) {
      this.$emit('use', item);
    },
  },
};
</script>

<style scoped>
.mr-8 {
  margin-right: 8px;
}
.text-overflow {
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
